import Settings from "../settings";

type UserInitParams = {
  userId: string;
  email?: string;
  phone?: string;
  fullName?: string;
  organizationId?: string | null;
  propertyId?: string | null;
  propertyName?: string;
  anonymousUserId?: string;
  roles: string[];
}

type ClientSignupParams = {
  userId: string;
  firstName: string;
  lastName: string;
  email: string | null;
  phone: string | null;
  anonymousUserId?: string;
}

export const getVisitorId = () : string => {
  if (!pendo?.getVisitorId) return "";

  return pendo.getVisitorId();
};

export const trackEvent = (eventName: string, metadata?: pendo.Metadata) : void => {
  if (!pendo?.track) return;

  pendo.track(eventName, metadata);
};

export const initializeUser = (params: UserInitParams) : void => {
  if (!pendo?.isReady) return;

  if (pendo.isReady()) {
    pendo.updateOptions({
      visitor: {
        id: params.userId,
        email: params.email || "",
        phone: params.phone || "",
        fullName: params.fullName || "",
        hcroles: params.roles || [""],
      },
      account: {
        id: params.propertyId || "",
        name: params.propertyName || "",
        organizationId: params.organizationId || "",
      },
    });
  } else {
    pendo.initialize({
      visitor: {
        id: params.userId,
        email: params.email || "",
        phone: params.phone || "",
        fullName: params.fullName || "",
        hcroles: params.roles || [""],
        env: Settings.env || "development",
        anonymousUserId: params.anonymousUserId || "",
      },
      account: {
        id: params.propertyId || "",
        name: params.propertyName || "",
        organizationId: params.organizationId || "",
      },
    });
  }
};

export const initializeUserLogin = (params: UserInitParams) : void => {
  initializeUser(params);
  trackEvent("user:logged_in");
};

export const initializeClientSignup = (params: ClientSignupParams) : void => {
  if (!pendo?.initialize) return;

  pendo.initialize({
    visitor: {
      id: params.userId,
      firstName: params.firstName,
      lastName: params.lastName,
      email: params.email || "",
      phone: params.phone || "",
      hcroles: ["client"],
      env: Settings.env || "development",
      anonymousUserId: params.anonymousUserId || "",
    },
  });

  trackEvent("user:created_account");
};
